import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd7f7aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-credit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "creditLabel" }, "De quanto seu negócio precisa", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "creditLabel" }, "Em quantas vezes você quer pagar?", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Faturamento mensual recomendado seria: ")
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = { class: "creditLabel" }
const _hoisted_7 = { class: "btn-next" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormCurrencyInput = _resolveComponent("FormCurrencyInput")!
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputError = _resolveComponent("InputError")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!

  return (_openBlock(), _createBlock(_Transition, { name: "show-user-credit" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_FormCurrencyInput, {
          class: "creditInput",
          placeholder: "R$ 0,00",
          "is-valid": "true",
          errors: [],
          modelValue: _ctx.credit,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credit) = $event)),
          currencyOptions: _ctx.currencyOptions
        }, null, 8, ["modelValue", "currencyOptions"]),
        _hoisted_3,
        _createVNode(_component_FormTextInput, {
          class: "installmentInput",
          type: "number",
          min: "6",
          max: "36",
          placeholder: "Quantos meses",
          "is-valid": "true",
          errors: [],
          modelValue: _ctx.installments,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.installments) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_InfoBox, { class: "info-box" }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_4,
              _createElementVNode("b", null, " R$ " + _toDisplayString(_ctx.minIncome), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.creditData.text.titleMotivo), 1),
          _createVNode(_component_MultiSelect, {
            options: _ctx.creditData.text.listReasons,
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event))
          }, null, 8, ["options", "modelValue"]),
          (_ctx.reason === _ctx.others)
            ? (_openBlock(), _createBlock(_component_FormTextInput, {
                key: 0,
                modelValue: _ctx.reasonOthers,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reasonOthers) = $event)),
                placeholder: "Motivo",
                name: "Motivo"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_InputError, {
              msg: _ctx.creditData.text.errors
            }, null, 8, ["msg"])
          ], 512), [
            [_vShow, _ctx.isInvalid]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ButtonDefault, {
            id: "btn-step-next-text-input",
            msg: "Continuar",
            onButtonClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSubmit()))
          })
        ])
      ])
    ]),
    _: 1
  }))
}